export default __webpack_public_path__ + "static/media/no_image_jacket.44ee3652.png";